// extracted by mini-css-extract-plugin
module.exports = {"adminHeader":"Header_adminHeader__1P4_r","officialImg":"Header_officialImg__3Wf3e","adminAddBtn":"Header_adminAddBtn__2lYPG"};